import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import type { SupportTicket } from '@partiri-cloud/types';

/**
 * @class ServiceEventApi
 * @description Events related to a service
 */
export class ContactApi {
  private endpoint = '/contact'
  constructor(private http: HttpClient) { }

  /**
   * Create a new project to combine services
   * @param project
   */
  public createSupportTicket(ticket: SupportTicket): Observable<SupportTicket> {
    return this.http.post<SupportTicket>(this.endpoint, ticket)
  }
}
